import { Component, OnInit, Input } from '@angular/core';
import { DataService} from 'src/app/services/data.service';

@Component({
  selector: 'app-suggest-profile',
  templateUrl: './suggest-profile.component.html',
  styleUrls: ['./suggest-profile.component.scss']
})
export class SuggestProfileComponent implements OnInit {
  docInfo: any = {
    actionMenuID: 0,
    docName: ''
  }
  isAdded: any = {
      compName: false,
      address: false,
      city: false,
      state: false,
      gstin: false,
      logo: false,
      digiSign: false
  }
  constructor(private dataSer: DataService) { }
  @Input() suggestProfileMdlRef: any;
  @Input() isPremiumAgencyPaid: any;
  @Input() limitCrossed: any;
  @Input() tableM: any;
  @Input() redirectToDoc: any;
  @Input() openSubMdl: any;
  @Input() getCfgAgnCfg: any;
  @Input() openUpgrade: any;

  ngOnInit(): void {
    this.getData();

    // Listens docInfo from app-component & data.service
    this.dataSer.docData.subscribe((value: any) => {
      if(value)
      this.docInfo  = value;
    });
  }
  
  
  getData(this: any) {
    let tblM = [];
    var mCookie: any = localStorage.getItem('M');
    if (mCookie) {
        mCookie = JSON.parse(mCookie);
        if (mCookie.length > 0) {
            tblM = mCookie;
        }
    }
    if (tblM.length > 0) {
      this.isAdded.compName = tblM[0].AgencyName ? true : false;
      this.isAdded.address = (tblM[0].AddressL1 || tblM[0].AddressL2) ? true : false;
      this.isAdded.gstin = tblM[0].GSTIN ? true : false;
      this.isAdded.logo = tblM[0].Logo ? true : false;
      this.isAdded.city = tblM[0].City ? true : false;
      this.isAdded.state = (tblM[0].State && tblM[0].StateID) ? true : false;
      this.isAdded.digiSign = tblM[0].DigiSign ? true : false;
    }
  }

  bzCloseMdl() {
    this.suggestProfileMdlRef.close();
  }

  openSetUpProfile() {
    var maxHeight = screen.height > 768 ? 768 : screen.height;
    var heightWidth = "height = " + maxHeight + ", width = 768px"; 
    window.open("../../../main.html#/ProfileSetup", "_blank", heightWidth);
  }

  redirectToEntry(id: number) {
    this.redirectToDoc(id)
  }
}
